(function () {
  'use strict';

  // Okendo's quiz widget programmatically calls .focus() on its bottom "Back"
  // button after each step transition. When the next step is taller than the
  // viewport, the browser's default focus-scroll yanks the page down to reveal
  // that button, producing a jarring jump to the bottom of the quiz.
  //
  // We patch HTMLElement.prototype.focus so any *programmatic* focus targeting
  // an element inside the quiz form is forced to use { preventScroll: true }.
  // Native keyboard tabbing does NOT route through this prototype method, so
  // real keyboard navigation (and its expected scroll-into-view) is unaffected.

  var QUIZ_SELECTOR = '.c-questionsForm, .c-questions, [class*="c-quiz"], [class*="oke-quizzes"]';

  var nativeFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (options) {
    try {
      if (this && this.closest && this.closest(QUIZ_SELECTOR)) {
        var opts = {};
        if (options && typeof options === 'object') {
          for (var key in options) {
            if (Object.prototype.hasOwnProperty.call(options, key)) {
              opts[key] = options[key];
            }
          }
        }
        opts.preventScroll = true;
        return nativeFocus.call(this, opts);
      }
    } catch (e) {
      /* fall through to default focus */
    }
    return nativeFocus.apply(this, arguments);
  };
})();
